// 优惠券
const messageList = () => import('@/pages/messageList/messageList.vue');
export default [
  {
    path: '/messageList',
    name: 'messageList',
    component: messageList,
    meta: {
      title: '消息',
      requireAuth: true,
    },
  },
];
